import Footer from '../Footer';
import Header from '../Header';

interface LayoutDownloadProps {
  children: React.ReactNode;
  className?: string;
}

export default function LayoutDownload({ children, className }: LayoutDownloadProps) {
  return (
    <div className='flex flex-col w-full min-h-screen'>
      <div className='sticky top-0 z-50 bg-white'>
        <Header />
      </div>

      <main className={`flex-1 ${className}`}>{children}</main>

      <Footer />
    </div>
  );
}
